export default __webpack_public_path__ + "static/media/MelbourneLevel1East.38d26d19.jpg";